const ChartTypes = [
  { name: "درخواست‌ها", value: "request" },
  { name: "زمان جوابگویی", value: "requestMsec" },
  { name: "ترافیک ارسال و دریافت", value: "net" },
  { name: "کد وضعیت", value: "status" },
  { name: "وضعیت استفاده از کش", value: "cache" },
  // { name: "میزان مصرف کش", value: "cacheuse" }
];
export default ChartTypes;